module.exports = __webpack_public_path__ + "img/p8-p2-text.26b63ca2.png";